const MessageStatus = [
    // 1
    "Ontvangen",
    // 2
    "wordt verwerkt",
    // 3
    "In retry",
    // 4
    "Afgeleverd",
    // 5
    "Handmatig verwerkt",
    // 6
    "Kon niet afgeleverd worden",
    // 7
    "Fout tijdens verwerking",
    // 8
    "Afgeleverd aan tussenpartij"
]
export default MessageStatus;